import { MissionRequestEnums } from "./constants";



export function GetMissionRequestResponseColor(response) {
  switch (response) {
    case MissionRequestEnums.ResponseState.New: return "#E8B731";
    case MissionRequestEnums.ResponseState.Accepted: return "#48C848";
    case MissionRequestEnums.ResponseState.Rejected: return "#F08484";
    default: return "#E8B731";
  }
}


const STYLE_NEW = { color: "#000000B8", background: "#F6E4B3" };
const STYLE_ACCEPTED = { color: "#1E4620", background: "#EDF7ED" };
const STYLE_REJECTED = { color: "#B80505", background: "#FDEDED" };

export function GetMissionRequestResponseChipStyle(response) {
  switch (response) {
    case MissionRequestEnums.ResponseState.New: return STYLE_NEW;
    case MissionRequestEnums.ResponseState.Accepted: return STYLE_ACCEPTED;
    case MissionRequestEnums.ResponseState.Rejected: return STYLE_REJECTED
    default: return STYLE_NEW;
  }
}